import { motion } from "framer-motion";


const containerPlaylist = {
  hidden: {
    opacity: 0,
    x: "100vh",
  },
  hiddenleft: {
    opacity: 0,
    x: "-100vh",
  },
  visible: {
    opacity: 1,
    x: "0",
    transition: {
      type: "spring",
      stiffness: 80,
    },
  },
};

const CardPricing = ({ item, handleClickPayment }) => {
  return (
    <motion.div
      className="card-pricing"

      variants={containerPlaylist}
      initial="hidden"
      animate="visible"
    >
      <div className={`card-pricing-header card-pricing-${item.name}`}>
        <h3>{item.name}</h3>
      </div>
      <div className="card-pricing-body">
        <div className="card-pricing-price">
          <span className="price-value">{item.price}</span>
          <span className="price-value">$</span>
        </div>
        <div className="card-pricing-features">
          <ul>
            {item.list.map((ele, i) => (
              <li key={i}>{ele}</li>
            ))}
          </ul>
        </div>
      </div>
      <div className="card-pricing-footer">
        <button
          className={`btn btn-select card-pricing-${item.name}`}
          onClick={(e) => handleClickPayment(e, item._id)}
        >
          Select
        </button>
      </div>
    </motion.div>
  );
};

export default CardPricing;
